// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcs_a bhe_qn bhe_qo bhe_ua bhe_cy bhe_ty bhe_gm bhe_ka"};